import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Phase1MenuItem } from './Phase1.types';

interface Phase1MenuContextData {
  selectedItem: Phase1MenuItem;
  setSelectedItem: (value: Phase1MenuItem) => void;
}

interface Phase1MenuProviderProps {
  children: ReactNode;
}

const Phase1MenuContext = createContext<Phase1MenuContextData | undefined>(undefined);

export function Phase1MenuProvider({ children }: Readonly<Phase1MenuProviderProps>) {
  const [selectedItem, setSelectedItem] = useState<Phase1MenuItem>('backgroundCheck');

  const value = React.useMemo(() => ({ selectedItem, setSelectedItem }), [selectedItem]);

  return <Phase1MenuContext.Provider value={value}>{children}</Phase1MenuContext.Provider>;
}

export function usePhase1Menu() {
  const context = useContext(Phase1MenuContext);

  if (!context) {
    throw new Error('usePhase1Menu must be used within a Phase1MenuProvider');
  }

  return context;
}
